import { sva } from '@agapi/ui/panda/css';
import { anatomy } from '@zag-js/popover';
export const popoverStyles = sva({
    slots: anatomy.keys(),
    base: {
        content: {},
        title: {
            fontWeight: 'bold',
            mb: '2',
        },
        description: {
            mb: '4',
        },
    },
});
